import CryptoJS from "crypto-js";

require("dotenv").config();
const secretKey = "asdjSU8*4.*sFGr";


export const getBrowserAlertText = () => {
    const browser = navigator.userAgent.toLowerCase();
    if (browser.indexOf('chrome') > -1) {
        return null;
    } else {
        return 'Google Chrome veya Microsoft Edge üzerinden yapılması durumunda sağlıklı çalışacaktır.';
    }
}



export const encryptData = (dataToEncrypt) => {
    const data = CryptoJS.AES.encrypt(
        dataToEncrypt,
        secretKey
    ).toString();

    return data
};

export const decryptData = (dataToDecrypt) => {
    const bytes = CryptoJS.AES.decrypt(dataToDecrypt, secretKey);
    const data = bytes.toString(CryptoJS.enc.Utf8);
    return data
};

export const validateEmail = (rawEmail) => {
    if (!rawEmail) return false;
    const email = rawEmail.normalize("NFKC").trim();
    const hasNonAscii = /[^\x00-\x7F]/;
    if (hasNonAscii.test(email)) return false;
    const re = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return re.test(email);
  };
